import React from 'react'
import SingleBed from '@material-ui/icons/SingleBed'

export default function SingleBedIcon(props) {
    const { ...other } = props

    return (
        <SingleBed {...other} />
    )
}